<template>
  <main class="px-4 pt-4">
    <h1 class="mb-0">
      {{ $t('Monitoring') }}
    </h1>
    <dx-data-grid
      ref="monitoringGrid"
      :data-source="dataSource"
      :remote-operations="remoteOperations"
      :allow-column-reordering="true"
      :show-borders="true"
      :column-min-width="50"
      :column-auto-width="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      :hover-state-enabled="true"
      date-serialization-format="yyyy-MM-dd"
      @toolbar-preparing="onToolbarPreparing"
    >
      <dx-column
        data-field="company"
        :caption="$t('company')"
        :lookup="companyLookup"
        :allow-editing="false"
        :fixed="true"
      />
      <dx-column
        data-field="monitoring.tk_order_number"
        :caption="$t('tk_order_number')"
      />
      <dx-column
        data-field="container"
        :caption="$t('container')"
        :allow-editing="false"
      />
      <dx-column
        data-field="prepare_to_ship_date"
        :caption="$t('prepare_to_ship_date')"
        data-type="date"
      />
      <dx-column
        data-field="shipping_start_date"
        :caption="$t('Shipping start date')"
        data-type="date"
      />
      <dx-column
        data-field="arrival_at_border_date"
        :caption="$t('Arrival at border date')"
        data-type="date"
      />
      <dx-column
        data-field="customs_procedure_type"
        :caption="$t('Сustoms procedure type')"
      />
      <dx-column
        data-field="delivery_terms"
        :caption="$t('Delivery terms')"
        :allow-editing="false"
      />
      <dx-column
        data-field="dispatch_location"
        :caption="$t('Dispatch location')"
        :allow-editing="false"
      />
      <dx-column
        data-field="border_crossing_point"
        :caption="$t('Border crossing point')"
        :allow-editing="false"
      />
      <dx-column
        data-field="destination"
        :caption="$t('Destination')"
        :allow-editing="false"
      />
      <dx-column
        data-field="monitoring.foreign_forwarder"
        :caption="$t('Foreign forwarder')"
      />
      <dx-column
        data-field="monitoring.foreign_shipping_invoice_no"
        :caption="$t('Foreign shipping invoice')"
      />
      <dx-column
        data-field="monitoring.foreign_shipping_cost"
        :caption="$t('Foreign shipping cost')"
      />
      <dx-column
        data-field="monitoring.foreign_shipping_currency"
        :caption="$t('Foreign shipping currency')"
      />
      <dx-column
        data-field="monitoring.internal_shipping_invoice_no"
        :caption="$t('Internal shipping invoice')"
      />
      <dx-column
        data-field="monitoring.internal_shipping_cost"
        :caption="$t('Internal shipping cost')"
      />
      <dx-column
        data-field="monitoring.internal_shipping_currency"
        :caption="$t('Internal shipping currency')"
      />
      <dx-column
        data-field="monitoring.additional_expenses"
        :caption="$t('Additional expenses')"
      />

      <dx-group-panel :visible="true" />
      <dx-editing
        v-if="user.is_manager"
        :allow-updating="true"
        :use-icons="true"
        mode="cell"
      />
      <dx-header-filter :visible="true" />
      <dx-search-panel
        :visible="true"
        :highlight-case-sensitive="false"
      />
      <dx-export
        :enabled="true"
        :allow-export-selected-data="true"
        file-name="monitoring"
      />
      <dx-column-chooser :enabled="true" />
      <dx-state-storing
        :enabled="true"
        type="localStorage"
        :storage-key="`u${user.id}-monitoring-grid-storage`"
      />
      <dx-paging :page-size="20" />
      <dx-pager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 15, 20, 50]"
      />
    </dx-data-grid>
  </main>
</template>

<script>
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxColumnChooser,
  DxEditing,
  DxHeaderFilter,
  DxGroupPanel,
  DxSearchPanel,
  DxStateStoring,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid';

import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import createCustomStore from '@/utils/create-custom-store';
import createFreightOrderLookup from '@/utils/create-freight-order-lookup';

export default {
  name: 'MonitoringGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxGroupPanel,
    DxSearchPanel,
    DxEditing,
    DxHeaderFilter,
    DxExport,
    DxColumnChooser,
    DxStateStoring,
    DxPaging,
    DxPager,
  },
  data: (vue) => ({
    remoteOperations: {
      sorting: true,
      filtering: true,
      paging: true,
    },
    dataSource: createCustomStore('tracking/api/monitoring/'),
    freightOrderLookup: createFreightOrderLookup(vue),
  }),
  computed: {
    ...mapState(['user']),
    companyLookup: () => ({
      dataSource: {
        store: createCustomStore('profile/api/companies/'),
        key: 'id',
      },
      valueExpr: 'id',
      displayExpr(company) {
        return company ? `${company.name} ${company.inn || ''}` : '';
      },
      allowClearing: true,
    }),
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        hint: this.$t('refresh'),
        options: {
          icon: 'ace-icon icon-refresh',
          hint: this.$t('refresh'),
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    refreshDataGrid() {
      this.$refs.monitoringGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.monitoringGrid.instance.clearFilter();
    },
  },
};
</script>
